import { ChatLayerObject } from './types'

export const CHATLAYER: ChatLayerObject = {
  url: process.env.REACT_APP_CHATLAYER_URL,
  config: {
    lang: 'pt',
    animation: 'grow',
    withCloseButton: true,
  },
  log: (message: string): void => {
    console.log(
      `%c [ChatLayer]: ${message}`,
      'background: #222; color: #bada55',
    )
  },
}

export const CHATLAYER_STATUS_API =
  'https://status.chatlayer.ai/api/v2/status.json'
